import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../models/authSlice";
import patientReducer from "../models/patientSlice";
import ayushBReducer from "../models/ayushmanBSlice";
import documentDeficiencyReducer from "../models/documentDeficiencySlice";
import navReducer from "../models/navSlice";
import hospitalReducer from "../models/hospitalSlice";
import caseReducer from "../models/casesSlice";
import schemeReducer from "../models/schemeSlice";
import claimReducer from "../models/claimSlice";
import doctorReducer from "../models/doctorSlice";
import referralReducer from "../models/referralSlice";
import healthCareReducer from "../models/healthCareSlice";
import preAuthSlice from "../models/preAuthSlice";
import ipdBillsReducer from "../models/ipdBillsSlice";
import opdBillsReducer from "../models/opdBillsSlice";
import billsReducer from "../models/billsSlice";

import { RESET_STORE } from "./actions";
import EnhancementSlice from "../models/EnhancementSlice";
import EnhancementSliceForCghs from "../models/EnhancementSliceForCghs";
import queriesReducer from "../models/preAuthQuerySlice"
import DischargeSlice from "../models/DischargeSlice";
import preAuthClaimSlice from "../models/preAuthClaimSlice";
import roleManagementSlice from "../models/roleManagementSlice";
import visitSlice from "../models/visitSlice";
import schemeOnboardingSlice from "../models/schemeOnboardingSlice";
import dashboardSlice from "../models/dashboardSlice";
import querySlice from "../models/querySlice";

const appReducer = combineReducers({
  auth: authReducer,
  patients: patientReducer,
  ayushBPreAuth: ayushBReducer,
  documentDeficiency: documentDeficiencyReducer,
  nav: navReducer,
  hospital: hospitalReducer,
  cases: caseReducer,
  scheme: schemeReducer,
  claim: claimReducer,
  doctor: doctorReducer,
  referral: referralReducer,
  healthCares: healthCareReducer,
  preAuth: preAuthSlice,
  enhancement: EnhancementSlice,
  enhancementCghs : EnhancementSliceForCghs,
  queries: queriesReducer,
  discharge: DischargeSlice,
  ipdBills: ipdBillsReducer,
  opdBills: opdBillsReducer,
  bills: billsReducer,
  preAuthClaim: preAuthClaimSlice,
  roleManagement: roleManagementSlice,
  visit: visitSlice,
  schemeOnboarding: schemeOnboardingSlice,
  dashboard : dashboardSlice,
  query: querySlice
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: any
) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
